import {ICasinoDeepLinkAction} from "../../casino-deep-link-action.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {AppIdentifiers, IDeepLink, IPerformActionPayloadBase, TriggerType} from "@sparkware/uc-sdk-core";
import {CHANNEL_SOURCE} from "../../../../../common/const/casinofied-analytics-consts";


export class UnifiedDeepLinkAction implements ICasinoDeepLinkAction {
    constructor(private readonly services: IServiceFactoryExtended,
                private readonly deepLink: IDeepLink) {
    }
    async execute(): Promise<void> {

        for(let deepLinkAction of this.deepLink.actions) {
            const channelAction = this.services.messageBroker.channels.performAction.topics[deepLinkAction.actionID];
            if(!channelAction) {
                throw new Error(`Invalid deep link action id ${deepLinkAction.actionID}`);
            }

            const correlationId = this.services.tools.getGuid();
            const payload: IPerformActionPayloadBase = {
                correlationID: correlationId,
                actionData: deepLinkAction.actionData,
                launchInfo: {
                    channel: {
                        area: this.deepLink.area,
                        source: this.deepLink.source,
                        element: this.deepLink.element ?? CHANNEL_SOURCE.casinoClient
                    },
                    appSpecificParameters: deepLinkAction.appSpecificParameters,
                    businessCorrelationID: correlationId,
                    trigger: TriggerType.automaticFlow,
                    sourceAppID: AppIdentifiers.CasinoClient,
                    sourceAppVersion: this.services.sdk.getSkin().getVersion()
                }
            };

            await channelAction.execute(payload as any);

        }
    }

}